import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectImage from '@/modules/Auth/assets/icons/selectModeIcon.svg?react';
import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import { AUTH_LINKS } from '@/modules/Auth/AUTH_LINKS.ts';
import { Box, Center } from 'styled-system/jsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import RadioCard from '@/modules/Auth/components/card/RadioCard.tsx';
import FixToBottom from '@/common/components/layouts/FixToBottom.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import { selectModeCardItemData } from '@/modules/Auth/data/selectMode.ts';

export default function () {
  return (
    <MainLayout>
      <SelectMode />
    </MainLayout>
  );
}
const SelectMode = () => {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState<
    'expert' | 'job-applicant'
  >();
  const handleNavigate = () => {
    if (selectedValue === 'expert') {
      navigate(AUTH_LINKS.login);
    } else {
      navigate(AUTH_LINKS.register);
    }
  };
  useEffect(() => {
    setSelectedValue('expert');
  }, []);

  return (
    <Box mt="2rem">
      <Center>
        <SelectImage />
      </Center>
      <Box my="2rem">
        <TitleDescription textStyle="h1" color="black-1">
          یکی از موارد زیر را انتخاب کنید :
        </TitleDescription>
        {selectModeCardItemData.map((item) => (
          <Box
            my="20px"
            onClick={() => {
              setSelectedValue(item.value);
            }}
            key={item.value}
          >
            <RadioCard
              title={item.title}
              description={item.description}
              value={item.value}
              activeValue={selectedValue}
              withRadioButton
            />
          </Box>
        ))}
      </Box>
      <FixToBottom>
        <Button disabled={!selectedValue} fullWidth onClick={handleNavigate}>
          ادامه
        </Button>
      </FixToBottom>
    </Box>
  );
};
